module.exports = __webpack_public_path__ + "memberBg.2b921596442b517d440d.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/src/assets/memberBg.jpg
// module id = ../../../../../src/assets/memberBg.jpg
// module chunks = main